import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import { PageBuilderItem, PAGE_BUILDER_CODE_COMPONENT } from '../page-builder-components.models';
import { PageBuilderComponentsService } from '../page-builder-components.service';

@Component({
    selector: 'abw-page-builder-result',
    templateUrl: './page-builder-result.component.html',
    styleUrls: ['./page-builder-result.component.scss']
})
export class PageBuilderResultComponent implements OnInit, OnChanges {
    @Input() config: PageBuilderItem[] = [];
    @Input() datas: any;
    posDesignerItems: PageBuilderItem[] = [];
    formComponentsModels = {};
    PAGE_BUILDER_CODE_COMPONENT = PAGE_BUILDER_CODE_COMPONENT;

    constructor(
        private pageBuilderComponentsService: PageBuilderComponentsService,
    ) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!!changes.config?.currentValue && !!changes.datas?.currentValue) {
            this.posDesignerItems = this.buildPageBuilderComponents(this.config);
            console.log(this.posDesignerItems);
        }
    }

    private buildPageBuilderRow(item: any) {
        const formModel = this.pageBuilderComponentsService.doBuildPageBuilderModel([item])[0];
        if (!formModel) { return null; }

        const formGroup = this.pageBuilderComponentsService.doBuildPageBuilderFormGroup([formModel]);
        return { ID: item.ID, FORM_MODEL: formModel, FORM_GROUP: formGroup };
    }

    private buildPageBuilderComponents(items: any) {
        let buildedItems = [];
        if (!items) { return; }
        items.forEach(item => {
            if (!!item.ITEMS) {
                if (item.CODE == PAGE_BUILDER_CODE_COMPONENT.ROW && !!item.BINDING/* && !!this.datas["WORKFLOW"][item.BINDING]*/) {
                    const rowsBinding = this.datas["WORKFLOW"][item.BINDING];
                    rowsBinding.forEach(rowBinding => {
                        const buildedItem = this.buildPageBuilderRow(item);
                        buildedItems.push(buildedItem);
                    });
                }
            } else {
                const buildedItem = this.buildPageBuilderRow(item);
                buildedItems.push(buildedItem);
            }
        });
        return items;
    }
}